//  Create an array from an object (discards keys)
// only converts if needed, otherwise return the array
// returns empty array if undefined
const objToArray = (obj) => {
	if (obj) {
		if (Array.isArray(obj)) {
			return obj
		}
		return Object.keys(obj).map(key => obj[key])
	}
	return []
}

export default objToArray



// WEBPACK FOOTER //
// ./src/utilities/objToArray.js